export default {"src":"/_next/static/media/MCD.d0ce7ecf.svg","height":18,"width":18};